import { Grid, Typography } from '@mui/material';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import { useTranslation } from 'react-i18next';

function NoOrdersSearchState() {
  const { t } = useTranslation(['description']);
  const message = t('orders.retrieve.no_search_orders', { ns: 'description' });
  return (
    <Grid
      container
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
    >
      <Grid item xs="auto">
        <SentimentDissatisfiedIcon
          sx={{ fontSize: 60, color: 'action.active', mb: 2, width: '100%' }}
        />
      </Grid>
      {message && (
        <Grid item xs="auto">
          <Typography variant="body2" align="center">
            {message}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
}

export default NoOrdersSearchState;
